import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import App from './App';
import { ThreadDetailPage } from './pages/ThreadDetailPage';
import { Index } from './pages/Index';
import { Discover } from './pages/Discover';
import { Insight } from './pages/Insight';
import { YoursPage } from './pages/YoursPage';
import { UserPage } from './pages/UserPage';
import { NotFoundScreen } from './components/shelves/transitions/NotFound';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />} errorElement={<NotFoundScreen />}>
      <Route index element={<Index />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/discover/:userId" element={<UserPage />} />
      <Route path="/t/:threadId" element={<ThreadDetailPage />} />
      <Route path="/insight" element={<Insight />} />
      <Route path="/yours" element={<YoursPage />} />
    </Route>
  )
);
